var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-container"},[_c('item-tip'),_c('menu-article',{attrs:{"id":_vm.id,"article":_vm.detail,"show-logo":_vm.ShowLogo,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }